// extracted by mini-css-extract-plugin
module.exports = {"drawDetailContainer":"DrawDetails_drawDetailContainer__YdVBz"};